import { useStoreGclid } from '../lib/use-store-gclid'

// Headless component that captures the Google Ads gclid tracking param from the landing
// URL into session storage. Mounted once at the app root so it runs on every checkout page,
export function GclidTracker() {
  useStoreGclid()

  return null
}
